import { render, staticRenderFns } from "./ProductListMiniTable.vue?vue&type=template&id=5a471962&scoped=true"
import script from "./ProductListMiniTable.vue?vue&type=script&lang=js"
export * from "./ProductListMiniTable.vue?vue&type=script&lang=js"
import style0 from "./ProductListMiniTable.vue?vue&type=style&index=0&id=5a471962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a471962",
  null
  
)

export default component.exports